// Uso algunos elementos como referencia para darle transparencia al header, es muy personalizado en cada interfaz  //

import React, { useState, createContext } from "react";

const ObserverContext = createContext({});

export function ObserverContextProvider({ children }) {
  const [elementInview, setElementInview] = useState(false);

  return (
    <ObserverContext.Provider value={{ elementInview, setElementInview }}>
      {children}
    </ObserverContext.Provider>
  );
}

export default ObserverContext;
